import React from 'react'
import { Button, DropdownMenu, Flex, useAppTheme } from '@workwhile/ui'
import { Ban, Banknote, EllipsisVertical } from 'lucide-react'
import { UserPayment, UserPaymentAdminAction } from 'api/payments'
import { useUserPaymentsContextValue } from '../context/UserPaymentsProvider'

type PaymentAction = {
  id: string
  label: string
  icon: React.ReactNode
  onClick: () => void
}

export const PaymentRowActions = ({ payment }: { payment: UserPayment }) => {
  const { space } = useAppTheme()
  const {
    actions: { openPayoutToAch, openCancelBonus },
  } = useUserPaymentsContextValue()

  const actions: PaymentAction[] = payment.availableActions.map((action) => {
    switch (action) {
      case UserPaymentAdminAction.PAYOUT_TO_ACH:
        return {
          id: 'payout-to-ach',
          label: 'Manual payout',
          icon: <Banknote size={14} />,
          onClick: () =>
            openPayoutToAch({
              userId: payment.userId,
              userName: payment.userName,
              paymentId: payment.id,
            }),
        }
      case UserPaymentAdminAction.CANCEL_BONUS:
        return {
          id: 'cancel-bonus',
          label: 'Cancel bonus',
          icon: <Ban size={14} />,
          onClick: () => openCancelBonus(payment),
        }
    }
  })

  if (actions.length === 0) {
    return null
  }

  return (
    <Flex justifyContent="center" alignItems="center" width="100%">
      <DropdownMenu
        trigger={
          <Button
            variant="secondary"
            kind="small"
            aria-label="Payment actions"
            style={{ paddingLeft: space[1], paddingRight: space[1] }}
          >
            <EllipsisVertical size={14} />
          </Button>
        }
      >
        {actions.map((action) => (
          <DropdownMenu.Item key={action.id} onClick={action.onClick}>
            <Flex as="span" alignItems="center" style={{ gap: 8 }}>
              {action.icon}
              {action.label}
            </Flex>
          </DropdownMenu.Item>
        ))}
      </DropdownMenu>
    </Flex>
  )
}
